/* The favicon monster rolling back and forth along the bottom of the work area while Fiona reads (ROLLER in client/app.ts).
   It rolls like a ball: the spin is worked out from how far it has travelled (angle = distance / radius), so it never slides,
   and it slows to a stop at each end before rolling back. The look lives in styles.css (.roller); reduced motion hides it. */
export const ROLLER = `<div class="roller" aria-hidden="true"><img src="/favicon.svg" alt="" draggable="false"></div>`;

const PERIOD = 9000; // ms for one trip there and back

export function mountRoller(root: HTMLElement = document.body): void {
  let frame = 0, start = 0;

  const step = (now: number): void => {
    const el = document.querySelector<HTMLElement>(".roller"), ball = el?.firstElementChild as HTMLElement | null;
    if (!el || !ball) { frame = 0; return; }
    const size = ball.offsetWidth, span = Math.max(0, el.clientWidth - size);
    // Eased along the cosine, so it slows down at each end and turns back rather than bouncing off.
    const x = span * (1 - Math.cos(((now - start) / PERIOD) * 2 * Math.PI)) / 2;
    ball.style.transform = `translateX(${x.toFixed(1)}px) rotate(${(x / (size / 2)).toFixed(4)}rad)`;
    frame = requestAnimationFrame(step);
  };
  // The app builds its markup with innerHTML, so start rolling whenever a roller turns up; the loop ends once it's gone.
  new MutationObserver(() => {
    if (!frame && document.querySelector(".roller")) { start = performance.now(); frame = requestAnimationFrame(step); }
  }).observe(root, { childList: true, subtree: true });
}
